export const paymentMethods ={
    nomina: '1',
    efectivo: '2',
    tarjeta: '3'
}

export const accountTypes = {
    employee: 1,
    company: 2
}